export { HeroMedia } from './HeroMedia'
